import _objectSpread from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["__scopeTooltip"],
  _excluded2 = ["forceMount"],
  _excluded3 = ["__scopeTooltip", "children", "aria-label", "portalled"],
  _excluded4 = ["__scopeTooltip"];
import { useId as e } from "@radix-ui/react-id";
import * as o from "@radix-ui/react-visually-hidden";
import { Slottable as t } from "@radix-ui/react-slot";
import { Portal as r } from "@radix-ui/react-portal";
import * as n from "@radix-ui/react-popper";
import { createPopperScope as i } from "@radix-ui/react-popper";
import { Primitive as a } from "@radix-ui/react-primitive";
import { Presence as l } from "@radix-ui/react-presence";
import { useRect as c } from "@radix-ui/react-use-rect";
import { usePrevious as s } from "@radix-ui/react-use-previous";
import { useEscapeKeydown as u } from "@radix-ui/react-use-escape-keydown";
import { useControllableState as p } from "@radix-ui/react-use-controllable-state";
import { createContextScope as d } from "@radix-ui/react-context";
import { useComposedRefs as m } from "@radix-ui/react-compose-refs";
import { composeEventHandlers as f } from "@radix-ui/primitive";
import * as T from "react";
import C from "@babel/runtime/helpers/esm/extends";
var _d = d("Tooltip", [i]),
  _d2 = _slicedToArray(_d, 2),
  w = _d2[0],
  x = _d2[1];
export { x as createTooltipScope };
var g = i(),
  E = 700,
  _w = w("TooltipProvider", {
    isOpenDelayed: !0,
    delayDuration: E,
    onOpen: function onOpen() {},
    onClose: function onClose() {}
  }),
  _w2 = _slicedToArray(_w, 2),
  v = _w2[0],
  b = _w2[1];
export var TooltipProvider = function TooltipProvider(e) {
  var o = e.__scopeTooltip,
    _e$delayDuration = e.delayDuration,
    t = _e$delayDuration === void 0 ? E : _e$delayDuration,
    _e$skipDelayDuration = e.skipDelayDuration,
    r = _e$skipDelayDuration === void 0 ? 300 : _e$skipDelayDuration,
    n = e.children,
    _T$useState = T.useState(!0),
    _T$useState2 = _slicedToArray(_T$useState, 2),
    i = _T$useState2[0],
    a = _T$useState2[1],
    l = T.useRef(0);
  return T.useEffect(function () {
    var e = l.current;
    return function () {
      return window.clearTimeout(e);
    };
  }, []), /*#__PURE__*/T.createElement(v, {
    scope: o,
    isOpenDelayed: i,
    delayDuration: t,
    onOpen: T.useCallback(function () {
      window.clearTimeout(l.current), a(!1);
    }, []),
    onClose: T.useCallback(function () {
      window.clearTimeout(l.current), l.current = window.setTimeout(function () {
        return a(!0);
      }, r);
    }, [r])
  }, n);
}; /*#__PURE__*/
var _w3 = w("Tooltip"),
  _w4 = _slicedToArray(_w3, 2),
  y = _w4[0],
  _ = _w4[1];
export var Tooltip = function Tooltip(o) {
  var t = o.__scopeTooltip,
    r = o.children,
    i = o.open,
    _o$defaultOpen = o.defaultOpen,
    a = _o$defaultOpen === void 0 ? !1 : _o$defaultOpen,
    l = o.onOpenChange,
    c = o.delayDuration,
    s = b("Tooltip", t),
    u = g(t),
    _T$useState3 = T.useState(null),
    _T$useState4 = _slicedToArray(_T$useState3, 2),
    d = _T$useState4[0],
    m = _T$useState4[1],
    f = e(),
    C = T.useRef(0),
    w = null != c ? c : s.delayDuration,
    x = T.useRef(!1),
    E = s.onOpen,
    v = s.onClose,
    _p = p({
      prop: i,
      defaultProp: a,
      onChange: function onChange(e) {
        e && (document.dispatchEvent(new CustomEvent("tooltip.open")), E()), null == l || l(e);
      }
    }),
    _p2 = _slicedToArray(_p, 2),
    _p2$ = _p2[0],
    _ = _p2$ === void 0 ? !1 : _p2$,
    h = _p2[1],
    k = T.useMemo(function () {
      return _ ? x.current ? "delayed-open" : "instant-open" : "closed";
    }, [_]),
    D = T.useCallback(function () {
      window.clearTimeout(C.current), x.current = !1, h(!0);
    }, [h]),
    O = T.useCallback(function () {
      window.clearTimeout(C.current), C.current = window.setTimeout(function () {
        x.current = !0, h(!0);
      }, w);
    }, [w, h]);
  return T.useEffect(function () {
    return function () {
      return window.clearTimeout(C.current);
    };
  }, []), /*#__PURE__*/T.createElement(n.Root, u, /*#__PURE__*/T.createElement(y, {
    scope: t,
    contentId: f,
    open: _,
    stateAttribute: k,
    trigger: d,
    onTriggerChange: m,
    onTriggerEnter: T.useCallback(function () {
      s.isOpenDelayed ? O() : D();
    }, [s.isOpenDelayed, O, D]),
    onOpen: T.useCallback(D, [D]),
    onClose: T.useCallback(function () {
      window.clearTimeout(C.current), h(!1), v();
    }, [h, v])
  }, r));
}; /*#__PURE__*/
export var TooltipTrigger = /*#__PURE__*/T.forwardRef(function (e, o) {
  var t = e.__scopeTooltip,
    r = _objectWithoutProperties(e, _excluded),
    i = _("TooltipTrigger", t),
    l = g(t),
    c = m(o, i.onTriggerChange),
    s = T.useRef(!1),
    u = T.useCallback(function () {
      return s.current = !1;
    }, []);
  return T.useEffect(function () {
    return function () {
      return document.removeEventListener("mouseup", u);
    };
  }, [u]), /*#__PURE__*/T.createElement(n.Anchor, C({
    asChild: !0
  }, l), /*#__PURE__*/T.createElement(a.button, C({
    "aria-describedby": i.open ? i.contentId : void 0,
    "data-state": i.stateAttribute
  }, r, {
    ref: c,
    onMouseEnter: f(e.onMouseEnter, i.onTriggerEnter),
    onMouseLeave: f(e.onMouseLeave, i.onClose),
    onMouseDown: f(e.onMouseDown, function () {
      i.onClose(), s.current = !0, document.addEventListener("mouseup", u, {
        once: !0
      });
    }),
    onFocus: f(e.onFocus, function () {
      s.current || i.onOpen();
    }),
    onBlur: f(e.onBlur, i.onClose),
    onClick: f(e.onClick, i.onClose)
  })));
}); /*#__PURE__*/
export var TooltipContent = /*#__PURE__*/T.forwardRef(function (e, o) {
  var t = e.forceMount,
    r = _objectWithoutProperties(e, _excluded2),
    n = _("TooltipContent", e.__scopeTooltip); /*#__PURE__*/
  return T.createElement(l, {
    present: t || n.open
  }, /*#__PURE__*/T.createElement(h, C({
    ref: o
  }, r)));
});
var h = /*#__PURE__*/T.forwardRef(function (e, i) {
  var a = e.__scopeTooltip,
    l = e.children,
    c = e["aria-label"],
    _e$portalled = e.portalled,
    s = _e$portalled === void 0 ? !0 : _e$portalled,
    p = _objectWithoutProperties(e, _excluded3),
    d = _("TooltipContent", a),
    m = g(a),
    f = s ? r : T.Fragment,
    w = d.onClose;
  return u(function () {
    return w();
  }), T.useEffect(function () {
    return document.addEventListener("tooltip.open", w), function () {
      return document.removeEventListener("tooltip.open", w);
    };
  }, [w]), /*#__PURE__*/T.createElement(f, null, /*#__PURE__*/T.createElement(k, {
    __scopeTooltip: a
  }), /*#__PURE__*/T.createElement(n.Content, C({
    "data-state": d.stateAttribute
  }, m, p, {
    ref: i,
    style: _objectSpread(_objectSpread({}, p.style), {}, {
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)"
    })
  }), /*#__PURE__*/T.createElement(t, null, l), /*#__PURE__*/T.createElement(o.Root, {
    id: d.contentId,
    role: "tooltip"
  }, c || l)));
}); /*#__PURE__*/
export var TooltipArrow = /*#__PURE__*/T.forwardRef(function (e, o) {
  var t = e.__scopeTooltip,
    r = _objectWithoutProperties(e, _excluded4),
    i = g(t); /*#__PURE__*/
  return T.createElement(n.Arrow, C({}, i, r, {
    ref: o
  }));
}); /*#__PURE__*/
function k(e) {
  var o = e.__scopeTooltip,
    t = _("CheckTriggerMoved", o),
    r = c(t.trigger),
    n = null == r ? void 0 : r.left,
    i = s(n),
    a = null == r ? void 0 : r.top,
    l = s(a),
    u = t.onClose;
  return T.useEffect(function () {
    (void 0 !== i && i !== n || void 0 !== l && l !== a) && u();
  }, [u, i, l, n, a]), null;
}
export var Provider = TooltipProvider;
export var Root = Tooltip;
export var Trigger = TooltipTrigger;
export var Content = TooltipContent;
export var Arrow = TooltipArrow;